import type { AccordionRowState } from '@components/settings/components/common/animatedTable/types';

export const getRowAccordionData = (row: AccordionRowState | boolean | undefined): unknown => {
  if (row && typeof row === 'object') return row.data;
  return undefined;
};

export const isRowExpanded = (row: AccordionRowState | boolean | undefined): boolean => {
  if (!row) return false;
  if (typeof row === 'object') return row.isExpanded === true;
  return !!row;
};
